import React from "react";

const Block = () => {
  const blocksData = [
    {
      value: "Gratis",
      label: "Gratis för alla krogpersonal att gå med",
    },
    {
      value: "Erbjudanden",
      label: "Låt din personal utnyttja erbjudanden",
    },
    {
      value: "4.8",
      label: "Average Ratings",
    },
    {
      value: "250+",
      label: "NFT Collections",
    },
  ];

  return (
    <>
      {blocksData.map((block, index) => (
        <div key={index}>
          <div>
            <span className="text-fill-transparent inline-block bg-gradient-to-r from-[#FFE993] to-[#FFB770] bg-clip-text font-display text-5xl font-semibold">
              {block.value}
            </span>
          </div>
          <span className="text-lg dark:text-white">{block.label}</span>
        </div>
      ))}
    </>
  );
};

export default Block;
